import React, { useState, useRef, useEffect } from 'react';
import SidebarNav from '../components/nav/SidebarNav';
import { Helmet } from 'react-helmet';
import cookies from '../utils/cookies';
import VendorModal from '../components/VendorModal';
import InformativeModal from '../components/InformativeModal';
import Footer from '../components/nav/Footer';
import ReactHintFactory from 'react-hint';
import { parseBool } from '../utils';
import { useHistory } from 'react-router-dom';
import Loading from '../components/Loading';
import { useSelector, useDispatch } from 'react-redux';
import { sessionUpdate } from '../slices/sessionSlice';

const Layout = ({ children }) => {
    const dispatch = useDispatch();
    const session = useSelector((state) => state.session);
    const [showInformativeModal, setShowInformativeModal] = useState(false);
    const [showVendorModal, setShowVendorModal] = useState(false);
    const [collapseSidebar, setCollapseSidebar] = useState(parseBool(cookies.get('sidebar')));
    
    useEffect(() => {
        if (!session.loading && session.isAuthenticated) {
            const hasSeenInformativeModal = window.localStorage.getItem('pass_informative_modal_seen') === 'true';
            const needsVendorModal = !session?.selectedVendor;
            
            if (!hasSeenInformativeModal) {
                setShowInformativeModal(true);
            } else if (needsVendorModal) {
                setShowVendorModal(true);
            }
        }
    }, [session.loading, session.isAuthenticated, session.selectedVendor]);
    
    const toggleSidebar = () => {
        setCollapseSidebar(!collapseSidebar);
        cookies.set('sidebar', !collapseSidebar);
    };
    let mainWrapper = useRef();
    let mq = window.matchMedia('only screen and (min-width: 64em)');
    let hintAt = mq.matches ? 'right' : 'bottom';
    const ReactHint = ReactHintFactory(React);
    const history = useHistory();

    const handleInformativeModalClose = () => {
        setShowInformativeModal(false);
        if (!session?.selectedVendor) {
            setShowVendorModal(true);
        }
    };

    const handleVendorChange = (vendor) => {
        if (!!vendor.id) {
            window.localStorage.setItem('pass_vendor', vendor.id);
            dispatch(
                sessionUpdate({
                    selectedVendor: vendor.id,
                    selectedVendorName: vendor.vendorname
                })
            );
        }
        setShowVendorModal(false);
    };

    return (
        <>
            {session.loading && <Loading />}
            {!session.loading && (
                <>
                    <Helmet>
                        <title>Passport</title>
                    </Helmet>
                    <div className="site-row pt-md-0">
                        <SidebarNav
                            toggleVendorChangeModal={() => {
                                setShowInformativeModal(false);
                                setShowVendorModal(true);
                            }}
                            toggleSidebar={toggleSidebar}
                            collapseSidebar={collapseSidebar}
                            isAdmin={session.isAdmin}
                            hintAt={hintAt}
                            location={history.location}
                        />
                        <div className="main-wrapper">
                            <main ref={mainWrapper} role="main">
                                <div className="page">{children}</div>
                                <ReactHint autoPosition events />
                            </main>
                            <Footer />
                        </div>
                        <InformativeModal visible={showInformativeModal} onClose={handleInformativeModalClose} />
                        <VendorModal visible={showVendorModal} onClose={handleVendorChange} />
                    </div>
                </>
            )}
        </>
    );
};

export default Layout;
